import { all, put, select, takeLatest, takeLeading } from 'typed-redux-saga';

import { safe } from '../../../../shared/helpers/redux-saga';
import { sagaErrorHandler } from '../../helpers/sagas-error-handlers';
import {
    selectPiPGridCurrentPage,
    selectShowNextPiPGridPageButton,
    selectShowPrevPiPGridPageButton,
} from './selectors';
import {
    incrementCloseRequestId,
    nextPiPGridPageAction,
    prevPiPGridPageAction,
    requestClosePiPAction,
    setPiPGridCurrentPage,
} from './slice';

function* nextPiPGridPageSaga() {
    const canNext = yield* select(selectShowNextPiPGridPageButton);
    if (!canNext) {
        return;
    }
    const currentPage = yield* select(selectPiPGridCurrentPage);
    yield* put(setPiPGridCurrentPage(currentPage + 1));
}

function* prevPiPGridPageSaga() {
    const canPrev = yield* select(selectShowPrevPiPGridPageButton);
    if (!canPrev) {
        return;
    }
    const currentPage = yield* select(selectPiPGridCurrentPage);
    yield* put(setPiPGridCurrentPage(currentPage - 1));
}

function* requestClosePiPActionSaga() {
    yield* put(incrementCloseRequestId());
}

export function* pipGridSagaWatcher() {
    yield* all([
        takeLeading(nextPiPGridPageAction, safe(sagaErrorHandler('nextPiPGridPageSaga'), nextPiPGridPageSaga)),
        takeLeading(prevPiPGridPageAction, safe(sagaErrorHandler('prevPiPGridPageSaga'), prevPiPGridPageSaga)),
        takeLatest(requestClosePiPAction, requestClosePiPActionSaga),
    ]);
}
